import { useMemo } from 'react';

import { InputFormField } from 'types';
import { defaultLanguage } from 'context';
import { useCourseContext } from 'context';

import { InputField } from '../fields';

export const FormInputField = ({
  id,
  label,
  options,
  placeholder,
  translations,
}: InputFormField) => {
  const isNumber = options?.type === 'number';
  const { language } = useCourseContext();

  const translation = useMemo(() => {
    if (!language || !translations || language === defaultLanguage) {
      return { label, placeholder };
    }

    const translation = translations[language];
    return {
      label: label ? translation?.label || label : label,
      placeholder: translation?.placeholder || placeholder,
    };
  }, [label, placeholder, language, translations]);

  return (
    <InputField
      name={id}
      fullWidth
      label={translation.label}
      placeholder={translation.placeholder}
      type={isNumber ? 'text' : options?.type}
      inputMode={isNumber ? 'numeric' : undefined}
      pattern={
        isNumber ? (options?.integer ? '[^0-9]' : '[^0-9.-]') : undefined
      }
    />
  );
};
